module.exports = __webpack_public_path__ + "img/IMG_8512_P_L.26009472.webp";